import { render } from "./NewCard.vue?vue&type=template&id=01a9d448&ts=true"
import script from "./NewCard.vue?vue&type=script&lang=ts"
export * from "./NewCard.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\proyectos_repositorio_institucional\\ed4\\ed4Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__